import {bootboxConfirm} from "../../backend/before";

$(() => {
    const shopViewContainer = document.getElementById('shop-view');
    const element = {
        formCart: {
            id: $('#form-cart'),
            productReference: $('input[name="pref"]'),
            quantity: $('input[name="qty"]'),
            criterias: $('input[name="criterias"]'),
            btnAddQuoteCart: $("#btn-add-quote-cart")
        },
        shop: {
            criteriaContent: $('#criteria-content'),
            productQuantity: $('#product-quantity'),
        },
        formCartReset: $('#form-cart-reset'),
        btnCartReset: $('#btn-cart-reset'),
        btnCartUpdate: $('#btn-cart-update'),
        btnEstimateShipping: $('#btn-shipping-estimate'),
        countrySelect: $('#cart-country'),
        btnRemoveCartItemClass: '.cart-table__column--remove',
        inputNumberCartItemClass: '.input-number__input',
        formCartUpdate: {
            id: $('#form-cart-update'),
            inputUpdate: $('input[name="update"]'),
        },
        cartShippingValue: $('#cart-shipping-value'),
        cartTaxValue: $('#cart-tax-value'),
        cartTotalValue: $('#cart-total-value'),
        btnCheckout: $('#btn-go-checkout'),
        inputNoteCartItemClass: '.product-note',
        btnQuoteCartUpdate: $('#btn-quote-cart-update'),
        btnQuoteCartReset: $('#btn-quote-cart-reset'),
        btnRemoveQuoteCartItemClass: '.cart-table__column--remove',
    };

    setTimeout(function () {
        const country = element.countrySelect.val();

        if (country !== 'EN') {
            element.btnEstimateShipping.trigger('click');
        }
    }, 100);

    $('body').on('click', '.product-card__addtocart', function (e) {
        e.preventDefault();
        let quantity = 1;
        const criterias = [];
        const productRef = $(this).data('pref');
        const extraProductId = $(this).data('extra-id');

        if (shopViewContainer && !extraProductId) {
            const criteriaCount = element.shop.criteriaContent.data('count');

            quantity = +element.shop.productQuantity.val() || 1;

            for (let i = 1; i <= criteriaCount; i++) {
                const control = $(`#criteria-${i}`);

                const value = +control.val();
                if (value < 1) {
                    break;
                }

                criterias.push([+control.data('id'), value]);
            }

            if (criterias.length !== criteriaCount) {
                return;
            }
        }

        if (!productRef) {
            return;
        }

        // console.log("Cart !!!!!!!", productRef, criterias, quantity, extraProductId);

        axios.post('/carts/store', { pref: productRef, qty: quantity, criterias, extraProductId })
            .then(() => {
                document.location.reload();
            });
    });

    element.btnCartReset.on('click', function (e) {
        e.preventDefault();

        bootboxConfirm('Confirmation', 'Do you really want to remove all items?', function () {
            axios.post('/carts/delete')
                .then(() => {
                    document.location.reload();
                });
        });
    });

    $(element.btnRemoveCartItemClass).on('click', function (e) {
        e.preventDefault();

        const rowId = $(this).data('rid');

        if (rowId) {
            bootboxConfirm('Confirmation', 'Do you really want to remove this item?', function () {
               axios.delete(`/carts/${rowId}/delete`).then(() => {
                   document.location.reload();
               })
            });
        }
    });

    element.btnCartUpdate.on('click', function (e) {
        e.preventDefault();

        const inputs = $(element.inputNumberCartItemClass);
        const length = inputs.length;

        const data = [];

        for (let i = 0; i < length; i++) {
            data.push([
                inputs.eq(i).data('rid'),
                inputs.eq(i).val(),
            ]);
        }

        axios.post('/carts/update', { update: data })
            .then(() => {
                document.location.reload();
            });
    });

    element.btnEstimateShipping.click(function (e) {
       const country = element.countrySelect.val();

        axios.get(`/carts/shipping-amount?countryCode=${country}`)
            .then((response) => {
                const { data } = response;

                element.cartShippingValue.text(`${Dinero({ amount: Math.ceil(data.amount) }).toFormat()}`);
                element.cartTaxValue.text(`${Dinero({ amount: Math.ceil(data.tax) }).toFormat()}`);
                element.cartTotalValue.text(`${Dinero({ amount: Math.ceil(data.total) }).toFormat()}`);
            })
            .catch((error) => {
                console.error(error);
            });
    });

    element.btnCheckout.click(function (e) {
        e.preventDefault();

        window.location = `/orders/checkout?country=${element.countrySelect.val() || "EN"}`;
    })

    element.formCart.btnAddQuoteCart.click(function (e) {
        e.preventDefault();
        let quantity = 1;
        const criterias = [];
        const productRef = $(this).data('pref');

        if (shopViewContainer) {
            const criteriaCount = element.shop.criteriaContent.data('count');

            quantity = +element.shop.productQuantity.val() || 1;

            for (let i = 1; i <= criteriaCount; i++) {
                const control = $(`#criteria-${i}`);

                const value = +control.val();
                if (value < 1) {
                    break;
                }

                criterias.push([+control.data('id'), value]);
            }

            if (criterias.length !== criteriaCount) {
                return;
            }
        }

        if (!productRef) {
            return;
        }

        axios.post('/quote-carts/store', { pref: productRef, qty: quantity, criterias })
            .then(() => {
                document.location.reload();
            });
    });

    element.btnQuoteCartUpdate.on('click', function (e) {
        e.preventDefault();

        const inputs = $(element.inputNumberCartItemClass);
        const length = inputs.length;

        const data = [];

        for (let i = 0; i < length; i++) {
            data.push([
                inputs.eq(i).data('rid'),
                { qty: inputs.eq(i).val(), note: $(`#product-note-${inputs.eq(i).data('rid')}`).val() },
            ]);
        }

        console.log(data);

        axios.post('/quote-carts/update', { update: data })
            .then(() => {
                document.location.reload();
            });
    });

    element.btnQuoteCartReset.on('click', function (e) {
        e.preventDefault();

        bootboxConfirm('Confirmation', 'Do you really want to remove all items?', function () {
            axios.post('/quote-carts/delete')
                .then(() => {
                    document.location.reload();
                });
        });
    });

    $(element.btnRemoveQuoteCartItemClass).on('click', function (e) {
        e.preventDefault();

        const rowId = $(this).data('rid');

        if (rowId) {
            bootboxConfirm('Confirmation', 'Do you really want to remove this item?', function () {
                axios.delete(`/quote-carts/${rowId}/delete`).then(() => {
                    document.location.reload();
                })
            });
        }
    });
});
